import styled from 'styled-components';

import ShipperOrderTableGroupTitle from './container';

export default styled(ShipperOrderTableGroupTitle)`
  display: flex;
  align-items: center;
  font-size: 21px;
  max-width: 1400px;
  margin: 0 auto;
  height: 50px;
  margin-top: ${(props) => props.theme.base.gridSizes.M};

  & > h3,
  & > h2 {
    margin: 0 8px 0 0;
    display: block;
    font-size: inherit;
  }
`;
